import React from "react";
import ReactDOM from "react-dom/client"; // ✅ Importación correcta para React 18
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext"; // Asegúrate de importar el contexto

const rootElement = document.getElementById("root"); // ✅ Obtiene el elemento del DOM correctamente
const root = ReactDOM.createRoot(rootElement); // ✅ Crea el root de React 18

root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

// Para medir el rendimiento de la app
reportWebVitals();
